// extracted by mini-css-extract-plugin
export var activeFilterButton = "_jr-c";
export var backButton = "_jr-4";
export var backIcon = "_jr-5";
export var chevronShortcut = "_jr-6";
export var container = "_jr-1";
export var editor = "_jr-8";
export var editorWrapper = "_jr-7";
export var prefix = "_jr-2";
export var searchIcon = "_jr-3";
export var suffix = "_jr-9";
export var suffixContent = "_jr-a";
export var suffixText = "_jr-b";
export var wrapper = "_jr-0";